// extracted by mini-css-extract-plugin
export default {"modalContainer":"J2FK2","modalHeader":"cBfDt","modalContent":"ZFXqP","closeButton":"md095","modalBody":"if8vl","modalFooter":"O1Czl"};